import React, { } from "react";
import { Bar } from "@ant-design/plots";

const BarChart = React.forwardRef(({
    color = () => "#5B8FF9",
    onReady = () => { },
    onClickBar = () => { },
    data = [{
        type: "Test1",
        sales: 38
    }],
    chartProps = {},
    style = {}
}, ref) => {
    const config = {
        data,
        xField: "sales",
        yField: "type",
        seriesField: "type",
        color,
        legend: false,
        ...chartProps
    };
    return (
        <div ref={ref} className="bar-chart" style={{ height: "100%", width: "100%", marginTop: "-5mm", ...style }}>
            <Bar
                {...config}
                onReady={(plot) => {
                    plot.on("plot:click", (...args) => {
                        onClickBar(...args);
                    });
                    onReady();
                }}
            />
        </div>
    );
});

export default BarChart;
